import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      originalSourceInfo: null,
      lastWindowPosition: null,
      isIgnoreMouseEventsActive: false,
      ignoreMouseEventsTimer: null,
      atScreen: null,
    };
  },
  computed: {
    ...mapState("live", [
      "screenShareStatus",
      "whiteBoardService",
      "liveService",
    ]),
  },
  beforeDestroy() {
    if (window.ipcRenderer) {
      if (this._shareWinBoundsListener) {
        window.ipcRenderer.removeListener(
          "share-window-bounds-changed",
          this._shareWinBoundsListener
        );
      }
      if (this._shareWinClosedListener) {
        window.ipcRenderer.removeListener(
          "share-window-closed",
          this._shareWinClosedListener
        );
      }
    }
  },
  methods: {
    ...mapMutations("live", []),
    screenShareOnMouseenter() {
      console.log("new_live_screenShareOnMouseenter");
      if (
        window.isElectron &&
        ["start", "pause"].includes(this.screenShareStatus)
      ) {
        console.log("new_live_screenShareOnMouseenter_setIgnoreMouseEvents");

        // window.LiveElectronApi?.setIgnoreMouseEvents?.(false);
      }
    },
    screenShareOnMouseleave() {
      console.log("new_live_screenShareOnMouseleave");
      if (
        window.isElectron &&
        ["start", "pause"].includes(this.screenShareStatus)
      ) {
        console.log("new_live_screenShareOnMouseleave_setIgnoreMouseEvents");
        // window.LiveElectronApi?.setIgnoreMouseEvents?.(true);
      }
    },
    // 开始白板与共享窗口的同步
    startSetIgnoreMouseEventsSync(sourceInfo) {
      if (!sourceInfo) {
        return;
      }

      console.log("开始白板同步，源信息:", sourceInfo);

      // 清除之前的监听器
      this.stopSetIgnoreMouseEventsSync();

      // 存储共享窗口信息
      this.originalSourceInfo = sourceInfo;
      this.lastWindowPosition = {
        x: sourceInfo.x,
        y: sourceInfo.y,
        width: sourceInfo.width,
        height: sourceInfo.height,
      };
      this.isIgnoreMouseEventsActive = false;

      // 初始化白板设置
      this.initializeBoardForSource(sourceInfo);

      // 监听setIgnoreMouseEvents的调用
      this.originalSetIgnoreMouseEvents =
        window.LiveElectronApi?.setIgnoreMouseEvents;

      // 注册共享窗口变化监听（来自主进程广播）
      try {
        if (window.ipcRenderer && !this._shareWinBoundsListener) {
          this._shareWinBoundsListener = (event, payload) => {
            if (!payload || !payload.bounds) return;
            this.updateBoardForBounds(payload.bounds);
          };
          window.ipcRenderer.on(
            "share-window-bounds-changed",
            this._shareWinBoundsListener
          );
        }
        if (window.ipcRenderer && !this._shareWinClosedListener) {
          this._shareWinClosedListener = () => {
            this.stopSetIgnoreMouseEventsSync();
          };
          window.ipcRenderer.on(
            "share-window-closed",
            this._shareWinClosedListener
          );
        }
      } catch (e) {
        console.warn("注册共享窗口监听失败", e);
      }
    },
    // 初始化白板设置（根据共享源类型）
    initializeBoardForSource(sourceInfo) {
      if (!sourceInfo) {
        return;
      }

      console.log("screen_share__初始化白板，源信息详情:", {
        sourceInfo: sourceInfo,
        type: sourceInfo.type,
        sourceType: sourceInfo.sourceType,
        name: sourceInfo.name,
        id: sourceInfo.id,
        width: sourceInfo.width,
        height: sourceInfo.height,
      });

      // 获取白板DOM元素 - 支持多种方式获取白板ID
      let boardId = this.whiteBoardService?.config?.id || "board";
      const dom = document.querySelector("#" + boardId);
      if (!dom) {
        console.warn("未找到白板DOM元素，ID:", boardId);
        return;
      }

      // 判断是屏幕还是窗口 - 改进判断逻辑
      const isScreen =
        sourceInfo.type === "screen" ||
        sourceInfo.sourceType === "screen" ||
        sourceInfo.type === 1 || // 某些API可能使用数字类型
        sourceInfo.sourceType === 1 ||
        (sourceInfo.name && sourceInfo.name.toLowerCase().includes("screen")) ||
        (sourceInfo.name && sourceInfo.name.toLowerCase().includes("显示器")) ||
        (sourceInfo.name && sourceInfo.name.toLowerCase().includes("monitor"));

      console.log("screen_share__判断结果 - 是否为屏幕:", isScreen);

      if (isScreen) {
        // 共享屏幕：设置白板为屏幕的宽高比
        console.log("screen_share__设置为屏幕模式");
        this.whiteBoardService.setFullContainer();
      } else {
        // 共享窗口：设置白板为窗口的宽高比和大小
        console.log("screen_share__设置为窗口模式");
        this.setBoardForWindow(sourceInfo);
      }
    },
    // 设置白板为窗口模式
    async setBoardForWindow(sourceInfo) {
      // 获取白板DOM元素 - 支持多种方式获取白板ID
      let boardId = this.whiteBoardService?.config?.id || "board";
      const dom = document.querySelector("#" + boardId);
      if (!dom) {
        console.warn("未找到白板DOM元素，ID:", boardId);
        return;
      }
      const logicalSource = await this.convertTRTCToLogicalCoordinates(
        sourceInfo
      );
      console.log("screen_share__logicalSource", logicalSource);
      // 检测操作系统
      const isWindows = navigator.platform.indexOf("Win") !== -1;
      console.log(
        "screen_share__检测到操作系统:",
        isWindows ? "Windows" : "其他"
      );

      // 获取所有显示器的缩放比例信息
      const allScreenList =
        await window.LiveElectronApi?.getAllScreenScaleRatio();
      console.log("screen_share__所有显示器信息:", allScreenList);

      // 获取当前应用窗口的位置和大小
      const currentPosition = window.LiveElectronApi?.getPosition?.() || [0, 0];
      const currentSize = window.LiveElectronApi?.getWindowSize?.() || [
        1920, 1080,
      ];

      console.log("screen_share__当前应用窗口信息:", {
        position: currentPosition,
        size: currentSize,
      });

      // 非Windows端或无法获取显示器信息时的默认处理
      console.log("使用默认坐标处理逻辑");

      // 直接使用TRTC返回的坐标
      const sourceX = logicalSource.x;
      const sourceY = logicalSource.y;
      const sourceWidth = logicalSource.width;
      const sourceHeight = logicalSource.height;

      console.log("共享窗口原始信息:", {
        x: sourceX,
        y: sourceY,
        width: sourceWidth,
        height: sourceHeight,
      });

      // 计算白板相对于当前应用窗口的位置偏移
      const offsetX = sourceX - currentPosition[0];
      const offsetY = sourceY - currentPosition[1];

      console.log("计算的位置偏移:", {
        offsetX: offsetX,
        offsetY: offsetY,
        sourceX,
        sourceY,
        currentPositionX: currentPosition[0],
        currentPositionY: currentPosition[1],
      });

      // 设置白板容器
      dom.style.position = "fixed";
      dom.style.left = `${Math.max(0, offsetX)}px`;
      dom.style.top = `${Math.max(0, offsetY)}px`;
      dom.style.width = `${sourceWidth}px`;
      dom.style.height = `${sourceHeight}px`;
      dom.style.zIndex = "1000";
      dom.style.backgroundColor = "transparent";

      // 设置白板比例
      if (this.whiteBoardService) {
        this.whiteBoardService.setBoardRatio(sourceWidth, sourceHeight);
        this.whiteBoardService.resizeBoard();
      }

      console.log("设置白板为窗口模式完成:", {
        originalSourceInfo: sourceInfo,
        calculatedOffset: {
          offsetX,
          offsetY,
        },
        domStyle: {
          left: dom.style.left,
          top: dom.style.top,
          width: dom.style.width,
          height: dom.style.height,
        },
      });
    },
    // 使用TRTC API获取当前窗口信息
    // async getCurrentWindowInfoElectron() {
    //   try {
    //     // 使用TRTC的getScreenCaptureSources获取窗口信息
    //     if (this.liveService && this.liveService.getScreenCaptureSources) {
    //       const sources = await this.liveService.getScreenCaptureSources({
    //         thumbHeight: 1,
    //         thumbWidth: 1,
    //         iconHeight: 1,
    //         iconWidth: 1,
    //       });

    //       console.log(
    //         "TRTC获取到的窗口列表:",
    //         sources.map((s) => ({
    //           name: s.sourceName,
    //           id: s.sourceId,
    //           x: s.x,
    //           y: s.y,
    //           width: s.width,
    //           height: s.height,
    //           type: s.type,
    //         }))
    //       );
    //       console.log("当前记录的窗口信息:", this.originalSourceInfo);

    //       // 根据ID精确匹配窗口
    //       let targetWindow = null;

    //       if (this.originalSourceInfo && this.originalSourceInfo.sourceId) {
    //         targetWindow = sources.find((source) => {
    //           return source.sourceId === this.originalSourceInfo.sourceId;
    //         });
    //       }

    //       if (targetWindow) {
    //         console.log("找到匹配的窗口:", targetWindow);
    //         return {
    //           x: targetWindow.x || 0,
    //           y: targetWindow.y || 0,
    //           width: targetWindow.width || this.originalSourceInfo?.width,
    //           height: targetWindow.height || this.originalSourceInfo?.height,
    //           name: targetWindow.sourceName,
    //           id: targetWindow.sourceId,
    //         };
    //       } else {
    //         console.warn(
    //           "未找到匹配的窗口，当前sourceId:",
    //           this.originalSourceInfo?.sourceId
    //         );
    //         console.warn(
    //           "可用窗口列表:",
    //           sources.map((s) => ({ name: s.sourceName, id: s.sourceId }))
    //         );
    //       }
    //     } else {
    //       console.warn("liveService或getScreenCaptureSources不可用");
    //     }
    //   } catch (error) {
    //     console.warn("TRTC API获取窗口信息失败:", error);
    //   }

    //   return null;
    // },
    // 更新窗口模式的白板位置和大小
    // updateBoardPositionAndSizeForWindow(currentWindowInfo) {
    //   // 获取白板DOM元素 - 支持多种方式获取白板ID
    //   let boardId = this.whiteBoardService?.config?.id || "board";
    //   const dom = document.querySelector("#" + boardId);
    //   if (!dom) {
    //     console.warn("未找到白板DOM元素，ID:", boardId);
    //     return;
    //   }

    //   // 检测操作系统
    //   const isWindows = navigator.platform.indexOf("Win") !== -1;

    //   // 获取当前窗口的位置和大小
    //   const currentPosition = window.LiveElectronApi?.getPosition?.() || [0, 0];
    //   const currentSize = window.LiveElectronApi?.getWindowSize?.() || [
    //     1920, 1080,
    //   ];

    //   // Windows端特殊处理：考虑DPI缩放
    //   if (isWindows) {
    //     console.log("Windows端：更新白板位置时考虑DPI缩放");

    //     // 获取显示器信息
    //     window.LiveElectronApi?.getAllScreenScaleRatio?.()
    //       .then((allScreenList) => {
    //         if (allScreenList && allScreenList.length > 0) {
    //           // 找到共享窗口所在的显示器
    //           let sourceDisplay = null;
    //           for (const display of allScreenList) {
    //             if (
    //               currentWindowInfo.x >= display.bounds.x &&
    //               currentWindowInfo.x <
    //               display.bounds.x + display.bounds.width &&
    //               currentWindowInfo.y >= display.bounds.y &&
    //               currentWindowInfo.y < display.bounds.y + display.bounds.height
    //             ) {
    //               sourceDisplay = display;
    //               break;
    //             }
    //           }

    //           // 找到当前应用窗口所在的显示器
    //           let appDisplay = null;
    //           for (const display of allScreenList) {
    //             if (
    //               currentPosition[0] >= display.bounds.x &&
    //               currentPosition[0] <
    //               display.bounds.x + display.bounds.width &&
    //               currentPosition[1] >= display.bounds.y &&
    //               currentPosition[1] < display.bounds.y + display.bounds.height
    //             ) {
    //               appDisplay = display;
    //               break;
    //             }
    //           }

    //           if (sourceDisplay && appDisplay) {
    //             const sourceScaleFactor = sourceDisplay.scaleFactor || 1;
    //             const appScaleFactor = appDisplay.scaleFactor || 1;

    //             // Windows端：转换为逻辑坐标计算
    //             const logicalSourceX = currentWindowInfo.x / sourceScaleFactor;
    //             const logicalSourceY = currentWindowInfo.y / sourceScaleFactor;
    //             const logicalSourceWidth =
    //               currentWindowInfo.width / sourceScaleFactor;
    //             const logicalSourceHeight =
    //               currentWindowInfo.height / sourceScaleFactor;

    //             const offsetX =
    //               logicalSourceX - currentPosition[0] / appScaleFactor;
    //             const offsetY =
    //               logicalSourceY - currentPosition[1] / appScaleFactor;

    //             console.log("Windows端更新白板位置:", {
    //               windowInfo: currentWindowInfo,
    //               logicalSource: {
    //                 x: logicalSourceX,
    //                 y: logicalSourceY,
    //                 width: logicalSourceWidth,
    //                 height: logicalSourceHeight,
    //               },
    //               currentPosition,
    //               calculatedOffset: { offsetX, offsetY },
    //               sourceScaleFactor,
    //               appScaleFactor,
    //             });

    //             // 更新白板容器
    //             dom.style.position = "fixed";
    //             dom.style.left = `${Math.max(0, offsetX)}px`;
    //             dom.style.top = `${Math.max(0, offsetY)}px`;
    //             dom.style.width = `${logicalSourceWidth}px`;
    //             dom.style.height = `${logicalSourceHeight}px`;

    //             // 更新白板比例
    //             if (this.whiteBoardService) {
    //               this.whiteBoardService.setBoardRatio(
    //                 logicalSourceWidth,
    //                 logicalSourceHeight
    //               );
    //               this.whiteBoardService.resizeBoard();
    //             }

    //             console.log("Windows端更新白板完成:", {
    //               domStyle: {
    //                 left: dom.style.left,
    //                 top: dom.style.top,
    //                 width: dom.style.width,
    //                 height: dom.style.height,
    //               },
    //             });

    //             return;
    //           }
    //         }

    //         // 如果无法获取显示器信息，使用默认逻辑
    //         this.updateBoardPositionDefault(
    //           currentWindowInfo,
    //           currentPosition,
    //           dom
    //         );
    //       })
    //       .catch((error) => {
    //         console.warn("获取显示器信息失败，使用默认逻辑:", error);
    //         this.updateBoardPositionDefault(
    //           currentWindowInfo,
    //           currentPosition,
    //           dom
    //         );
    //       });
    //   } else {
    //     // 非Windows端使用默认逻辑
    //     this.updateBoardPositionDefault(
    //       currentWindowInfo,
    //       currentPosition,
    //       dom
    //     );
    //   }
    // },

    // 默认的位置更新逻辑
    // updateBoardPositionDefault(currentWindowInfo, currentPosition, dom) {
    //   // 计算共享窗口相对于当前窗口的位置偏移
    //   const offsetX = currentWindowInfo.x - currentPosition[0];
    //   const offsetY = currentWindowInfo.y - currentPosition[1];

    //   console.log("使用默认逻辑更新白板位置:", {
    //     windowInfo: currentWindowInfo,
    //     currentPosition,
    //     calculatedOffset: { offsetX, offsetY },
    //   });

    //   // 更新白板容器的位置和大小
    //   dom.style.position = "fixed";
    //   dom.style.left = `${Math.max(0, offsetX)}px`;
    //   dom.style.top = `${Math.max(0, offsetY)}px`;
    //   dom.style.width = `${currentWindowInfo.width}px`;
    //   dom.style.height = `${currentWindowInfo.height}px`;

    //   // 更新白板比例
    //   if (this.whiteBoardService) {
    //     this.whiteBoardService.setBoardRatio(
    //       currentWindowInfo.width,
    //       currentWindowInfo.height
    //     );
    //     this.whiteBoardService.resizeBoard();
    //   }

    //   console.log("默认逻辑更新白板完成:", {
    //     x: currentWindowInfo.x,
    //     y: currentWindowInfo.y,
    //     width: currentWindowInfo.width,
    //     height: currentWindowInfo.height,
    //     domStyle: {
    //       left: dom.style.left,
    //       top: dom.style.top,
    //       width: dom.style.width,
    //       height: dom.style.height,
    //     },
    //   });
    // },
    // 更新屏幕模式的白板位置
    // updateBoardPositionForScreen(currentWindowInfo) {
    //   // 获取白板DOM元素 - 支持多种方式获取白板ID
    //   let boardId = this.whiteBoardService?.config?.id || "board";
    //   const dom = document.querySelector("#" + boardId);
    //   if (!dom) {
    //     console.warn("未找到白板DOM元素，ID:", boardId);
    //     return;
    //   }

    //   // 屏幕模式：白板大小不变，只更新位置
    //   const screenWidth = window.screen?.availWidth || 1920;
    //   const screenHeight = window.screen?.availHeight || 1080;

    //   dom.style.position = "fixed";
    //   dom.style.left = "0px";
    //   dom.style.top = "0px";
    //   dom.style.width = `${screenWidth}px`;
    //   dom.style.height = `${screenHeight}px`;

    //   console.log("更新屏幕模式白板位置");
    // },
    // 更新白板以适应窗口变化
    // updateBoardForWindowChange(currentWindowInfo) {
    //   if (!this.originalSourceInfo) {
    //     return;
    //   }

    //   // 获取白板DOM元素 - 支持多种方式获取白板ID
    //   let boardId = this.whiteBoardService?.config?.id || "board";
    //   const dom = document.querySelector("#" + boardId);
    //   if (!dom) {
    //     console.warn("未找到白板DOM元素，ID:", boardId);
    //     return;
    //   }

    //   // 判断是屏幕还是窗口
    //   const isScreen =
    //     this.originalSourceInfo.type === "screen" ||
    //     this.originalSourceInfo.sourceType === "screen";

    //   if (isScreen) {
    //     // 屏幕模式：只更新位置，大小保持不变
    //     this.updateBoardPositionForScreen(currentWindowInfo);
    //   } else {
    //     // 窗口模式：更新位置和大小
    //     this.updateBoardPositionAndSizeForWindow(currentWindowInfo);
    //   }
    // },
    // 检查忽略鼠标事件时的窗口位置变化
    // checkIgnoreMouseEventsWindowPosition() {
    //   console.log("checkIgnoreMouseEventsWindowPosition___");

    //   if (!this.originalSourceInfo) {
    //     return;
    //   }

    //   try {
    //     // 使用Electron API获取当前窗口信息
    //     this.getCurrentWindowInfoElectron()
    //       .then((currentWindowInfo) => {
    //         if (!currentWindowInfo) {
    //           console.warn("无法获取当前窗口信息");
    //           return;
    //         }

    //         // 检查位置或大小是否发生变化
    //         const positionChanged =
    //           currentWindowInfo.x !== this.lastWindowPosition?.x ||
    //           currentWindowInfo.y !== this.lastWindowPosition?.y;
    //         const sizeChanged =
    //           currentWindowInfo.width !== this.lastWindowPosition?.width ||
    //           currentWindowInfo.height !== this.lastWindowPosition?.height;

    //         if (positionChanged || sizeChanged) {
    //           console.log("检测到共享窗口变化 (Electron):", {
    //             position: positionChanged ? "changed" : "unchanged",
    //             size: sizeChanged ? "changed" : "unchanged",
    //             old: this.lastWindowPosition,
    //             new: currentWindowInfo,
    //           });

    //           // 更新白板位置和大小
    //           this.updateBoardForWindowChange(currentWindowInfo);

    //           // 更新记录的位置
    //           this.lastWindowPosition = {
    //             x: currentWindowInfo.x,
    //             y: currentWindowInfo.y,
    //             width: currentWindowInfo.width,
    //             height: currentWindowInfo.height,
    //           };
    //         } else {
    //           console.log("窗口位置和大小未发生变化");
    //         }
    //       })
    //       .catch((error) => {
    //         console.warn("获取窗口信息失败 (Electron):", error);
    //       });
    //   } catch (error) {
    //     console.warn("检查窗口位置变化失败:", error);
    //   }
    // },
    // 停止忽略鼠标事件期间的轮询
    stopIgnoreMouseEventsPolling() {
      if (this.ignoreMouseEventsTimer) {
        clearInterval(this.ignoreMouseEventsTimer);
        this.ignoreMouseEventsTimer = null;
        console.log("停止轮询检查窗口位置变化");
      }
    },
    // 开始忽略鼠标事件期间的轮询
    startIgnoreMouseEventsPolling() {
      if (this.ignoreMouseEventsTimer) {
        clearInterval(this.ignoreMouseEventsTimer);
      }

      console.log("开始轮询检查窗口位置变化");

      // 点击穿透期间，每800ms检查一次窗口位置
      // this.ignoreMouseEventsTimer = setInterval(() => {
      //   console.log("执行轮询检查...");
      //   this.checkIgnoreMouseEventsWindowPosition();
      // }, 800);
    },
    // 停止setIgnoreMouseEvents监听
    stopSetIgnoreMouseEventsSync() {
      // 恢复原始的setIgnoreMouseEvents方法
      if (this.originalSetIgnoreMouseEvents) {
        window.LiveElectronApi.setIgnoreMouseEvents =
          this.originalSetIgnoreMouseEvents;
        this.originalSetIgnoreMouseEvents = null;
      }

      // 还原白板状态
      this.resetBoardState();
    },
    // 还原白板状态
    resetBoardState() {
      console.log("还原白板状态");

      // 获取白板DOM元素
      let boardId = this.whiteBoardService?.config?.id || "board";
      const dom = document.querySelector("#" + boardId);
      if (dom) {
        // 还原白板样式
        dom.style.position = "";
        dom.style.left = "";
        dom.style.top = "";
        dom.style.width = "";
        dom.style.height = "";
        dom.style.zIndex = "";
        dom.style.backgroundColor = "";
        console.log("已还原白板样式");
      }

      // 停止轮询
      this.stopIgnoreMouseEventsPolling();

      // 取消共享窗口变化监听
      try {
        if (window.ipcRenderer) {
          if (this._shareWinBoundsListener) {
            window.ipcRenderer.removeListener(
              "share-window-bounds-changed",
              this._shareWinBoundsListener
            );
            this._shareWinBoundsListener = null;
          }
          if (this._shareWinClosedListener) {
            window.ipcRenderer.removeListener(
              "share-window-closed",
              this._shareWinClosedListener
            );
            this._shareWinClosedListener = null;
          }
        }
      } catch (e) {
        console.warn("取消共享窗口监听失败", e);
      }

      // 清除状态
      this.originalSourceInfo = null;
      this.lastWindowPosition = null;
      this.isIgnoreMouseEventsActive = false;

      console.log("白板状态已还原");
    },
    // 根据主进程广播的 bounds 更新白板位置大小
    updateBoardForBounds(bounds) {
      if (!bounds) return;
      // 获取白板DOM元素 - 支持多种方式获取白板ID
      let boardId = this.whiteBoardService?.config?.id || "board";
      const dom = document.querySelector("#" + boardId);
      if (!dom) {
        console.warn("未找到白板DOM元素，ID:", boardId);
        return;
      }

      // 获取当前应用窗口的位置
      const currentPosition = window.LiveElectronApi?.getPosition?.() || [0, 0];

      const offsetX = bounds.x - currentPosition[0];
      const offsetY = bounds.y - currentPosition[1];

      dom.style.position = "fixed";
      dom.style.left = `${Math.max(0, offsetX)}px`;
      dom.style.top = `${Math.max(0, offsetY)}px`;
      dom.style.width = `${bounds.width}px`;
      dom.style.height = `${bounds.height}px`;
      dom.style.zIndex = "1000";
      dom.style.backgroundColor = "transparent";

      if (this.whiteBoardService) {
        this.whiteBoardService.setBoardRatio(bounds.width, bounds.height);
        this.whiteBoardService.resizeBoard();
      }
    },
    // 专门用于TRTC坐标转换的方法
    // 将TRTC获取的物理坐标转换为逻辑坐标，考虑多显示器和不同缩放比
    async convertTRTCToLogicalCoordinates(trtcSourceInfo) {
      try {
        if (!trtcSourceInfo) {
          console.warn("TRTC源信息为空");
          return null;
        }

        console.log("开始转换TRTC坐标:", trtcSourceInfo);

        // 检测操作系统
        const isMac = navigator.platform.indexOf("Mac") !== -1;
        const isWindows = navigator.platform.indexOf("Win") !== -1;

        console.log("操作系统检测:", { isMac, isWindows });

        // 获取所有显示器信息
        const allScreenList =
          await window.LiveElectronApi?.getAllScreenScaleRatio();

        if (!allScreenList || allScreenList.length === 0) {
          console.warn("无法获取显示器信息，返回原始坐标");
          return {
            x: trtcSourceInfo.x,
            y: trtcSourceInfo.y,
            width: trtcSourceInfo.width,
            height: trtcSourceInfo.height,
            name: trtcSourceInfo.name,
            id: trtcSourceInfo.sourceId || trtcSourceInfo.id,
            type: trtcSourceInfo.type,
            sourceType: trtcSourceInfo.sourceType,
          };
        }

        console.log("获取到显示器列表:", allScreenList);

        // 找到TRTC窗口所在的显示器
        let targetDisplay = null;
        let displayIndex = -1;

        for (let i = 0; i < allScreenList.length; i++) {
          const display = allScreenList[i];

          // 检查窗口是否在这个显示器范围内
          const isInDisplay =
            trtcSourceInfo.x >= display.bounds.x &&
            trtcSourceInfo.x < display.bounds.x + display.bounds.width &&
            trtcSourceInfo.y >= display.bounds.y &&
            trtcSourceInfo.y < display.bounds.y + display.bounds.height;

          console.log(`显示器 ${i + 1}:`, {
            bounds: display.bounds,
            scaleFactor: display.scaleFactor,
            isInDisplay,
            windowPos: { x: trtcSourceInfo.x, y: trtcSourceInfo.y },
          });

          if (isInDisplay) {
            targetDisplay = display;
            displayIndex = i;
            break;
          }
        }

        if (!targetDisplay) {
          console.warn("无法确定TRTC窗口所在显示器，尝试使用主显示器");
          // 如果无法确定，使用第一个显示器（通常是主显示器）
          targetDisplay = allScreenList[0];
          displayIndex = 0;
        }

        const scaleFactor = targetDisplay.scaleFactor || 1;
        console.log(`使用显示器 ${displayIndex + 1}，缩放因子: ${scaleFactor}`);

        // 根据操作系统采用不同的转换逻辑
        let logicalCoordinates;

        if (isMac) {
          // macOS: TRTC返回的坐标已经是逻辑坐标，不需要转换
          // 但需要验证这个假设
          console.log("macOS系统：TRTC坐标可能已经是逻辑坐标");

          // 验证：如果缩放因子是2，但坐标看起来合理，说明已经是逻辑坐标
          const isLikelyLogical =
            scaleFactor === 2 &&
            trtcSourceInfo.width <= 3000 &&
            trtcSourceInfo.height <= 2000;

          if (isLikelyLogical) {
            console.log("macOS: 检测到TRTC坐标已经是逻辑坐标，直接使用");
            logicalCoordinates = {
              x: trtcSourceInfo.x,
              y: trtcSourceInfo.y,
              width: trtcSourceInfo.width,
              height: trtcSourceInfo.height,
              name: trtcSourceInfo.name,
              id: trtcSourceInfo.sourceId || trtcSourceInfo.id,
              type: trtcSourceInfo.type,
              sourceType: trtcSourceInfo.sourceType,
              _conversionInfo: {
                originalDisplay: targetDisplay,
                scaleFactor,
                displayIndex,
                isEstimated: !targetDisplay,
                os: "macOS",
                conversionType: "none",
                reason: "TRTC坐标已经是逻辑坐标",
              },
            };
          } else {
            console.log("macOS: 检测到TRTC坐标可能是物理坐标，进行转换");
            logicalCoordinates = {
              x: Math.round(trtcSourceInfo.x / scaleFactor),
              y: Math.round(trtcSourceInfo.y / scaleFactor),
              width: Math.round(trtcSourceInfo.width / scaleFactor),
              height: Math.round(trtcSourceInfo.height / scaleFactor),
              name: trtcSourceInfo.name,
              id: trtcSourceInfo.sourceId || trtcSourceInfo.id,
              type: trtcSourceInfo.type,
              sourceType: trtcSourceInfo.sourceType,
              _conversionInfo: {
                originalDisplay: targetDisplay,
                scaleFactor,
                displayIndex,
                isEstimated: !targetDisplay,
                os: "macOS",
                conversionType: "physical_to_logical",
                reason: "TRTC坐标是物理坐标，已转换",
              },
            };
          }
        } else {
          // 将TRTC的物理坐标转换为逻辑坐标
          logicalCoordinates = {
            x: Math.round((trtcSourceInfo.x - this.atScreen.x) / scaleFactor),
            y: Math.round((trtcSourceInfo.y - this.atScreen.y) / scaleFactor),
            width: Math.round(trtcSourceInfo.width / scaleFactor),
            height: Math.round(trtcSourceInfo.height / scaleFactor),
            name: trtcSourceInfo.name,
            id: trtcSourceInfo.sourceId || trtcSourceInfo.id,
            type: trtcSourceInfo.type,
            sourceType: trtcSourceInfo.sourceType,
            // 保存转换信息，便于调试
            _conversionInfo: {
              originalDisplay: targetDisplay,
              scaleFactor,
              displayIndex,
              isEstimated: !targetDisplay,
            },
          };
        }

        console.log("TRTC坐标转换完成:", {
          original: {
            x: trtcSourceInfo.x,
            y: trtcSourceInfo.y,
            width: trtcSourceInfo.width,
            height: trtcSourceInfo.height,
          },
          logical: {
            x: logicalCoordinates.x,
            y: logicalCoordinates.y,
            width: logicalCoordinates.width,
            height: logicalCoordinates.height,
          },
          display: {
            index: displayIndex,
            bounds: targetDisplay.bounds,
            scaleFactor,
          },
        });

        return logicalCoordinates;
      } catch (error) {
        console.error("TRTC坐标转换失败:", error);

        // 返回原始坐标作为降级方案
        return {
          x: trtcSourceInfo.x,
          y: trtcSourceInfo.y,
          width: trtcSourceInfo.width,
          height: trtcSourceInfo.height,
          name: trtcSourceInfo.name,
          id: trtcSourceInfo.sourceId || trtcSourceInfo.id,
          type: trtcSourceInfo.type,
          sourceType: trtcSourceInfo.sourceType,
          _conversionInfo: {
            error: error.message,
            fallback: true,
          },
        };
      }
    },
    // 获取最大化窗口相对于屏幕的位置和大小
    async getMaximizedWindowInfo() {
      try {
        // 获取当前应用窗口的位置和大小
        const currentPosition = window.LiveElectronApi?.getPosition?.() || [
          0, 0,
        ];
        const currentSize = window.LiveElectronApi?.getWindowSize?.() || [
          1920, 1080,
        ];

        // 获取所有显示器信息
        const allScreenList =
          await window.LiveElectronApi?.getAllScreenScaleRatio();

        console.log("获取最大化窗口信息:", {
          currentPosition,
          currentSize,
          allScreenList,
        });

        if (!allScreenList || allScreenList.length === 0) {
          // 无法获取显示器信息时的降级处理
          return {
            x: currentPosition[0],
            y: currentPosition[1],
            width: currentSize[0],
            height: currentSize[1],
            screenWidth: window.screen?.availWidth || 1920,
            screenHeight: window.screen?.availHeight || 1080,
            isMaximized: true,
            _fallback: true,
          };
        }

        // 找到当前窗口所在的显示器
        let targetDisplay = null;
        for (const display of allScreenList) {
          if (
            currentPosition[0] >= display.bounds.x &&
            currentPosition[0] < display.bounds.x + display.bounds.width &&
            currentPosition[1] >= display.bounds.y &&
            currentPosition[1] < display.bounds.y + display.bounds.height
          ) {
            targetDisplay = display;
            break;
          }
        }

        // 如果找不到对应显示器，使用第一个显示器
        if (!targetDisplay) {
          targetDisplay = allScreenList[0];
        }

        const scaleFactor = targetDisplay.scaleFactor || 1;

        // 计算窗口相对于屏幕的位置（考虑缩放因子）
        const relativeX =
          (currentPosition[0] - targetDisplay.bounds.x) / scaleFactor;
        const relativeY =
          (currentPosition[1] - targetDisplay.bounds.y) / scaleFactor;
        const relativeWidth = currentSize[0] / scaleFactor;
        const relativeHeight = currentSize[1] / scaleFactor;

        const result = {
          x: relativeX,
          y: relativeY,
          width: relativeWidth,
          height: relativeHeight,
          screenWidth: targetDisplay.bounds.width / scaleFactor,
          screenHeight: targetDisplay.bounds.height / scaleFactor,
          displayBounds: targetDisplay.bounds,
          scaleFactor,
          isMaximized: true,
          _displayInfo: {
            index: allScreenList.indexOf(targetDisplay),
            bounds: targetDisplay.bounds,
            scaleFactor,
          },
        };

        console.log("最大化窗口信息计算结果:", result);
        return result;
      } catch (error) {
        console.error("获取最大化窗口信息失败:", error);

        // 降级处理：使用基本屏幕信息
        return {
          x: 0,
          y: 0,
          width: window.screen?.availWidth || 1920,
          height: window.screen?.availHeight || 1080,
          screenWidth: window.screen?.availWidth || 1920,
          screenHeight: window.screen?.availHeight || 1080,
          isMaximized: true,
          _error: error.message,
          _fallback: true,
        };
      }
    },
  },
};
